import { availablePlans, PlanInfo } from 'interfaces/payment/plans';
import { SubscribeCurrentUserQuery } from 'interfaces/graphql-typings';
import subscriptionText from './subscribeContainerText';

const determineAvailablePlans = (
  user: SubscribeCurrentUserQuery['currentUser']
): PlanInfo[] | [] => {
  const { buyside, retail } = availablePlans;

  if (!user) return [];

  const { isRetail } = user;

  if (isRetail) {
    return retail.map((plan): PlanInfo => subscriptionText[plan]);
  } else {
    return buyside.map((plan): PlanInfo => subscriptionText[plan]);
  }
};

export { determineAvailablePlans };
